import axios from "./axios"; // Import the centralized Axios instance
import prm from "./prm";

const state = {
  users: [],
};

const getters = {
  allUsers: (state) => state.users,
};

const actions = {
  async fetchUsers({ commit }, params = {}) {
    try {
      commit("resetUsers");
      const response = await axios.get("/users", { params: prm(params) });
      commit("setUsers", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch users:", error);
    }
  },
  async createUser({ commit }, user) {
    try {
      const response = await axios.post("/users", user);
      commit("addUser", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to create user:", error);
      throw error;
    }
  },
  async fetchUserById(_, id) {
    try {
      const response = await axios.get(`/users/${id}`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch user:", error);
      throw error;
    }
  },
  async updateUser({ commit }, user) {
    try {
      const response = await axios.put(`/users/${user.id}`, user);
      commit("updateUser", response.data);
    } catch (error) {
      console.error("Failed to update user:", error);
      throw error;
    }
  },
  async deleteUserById({ commit }, id) {
    try {
      const response = await axios.delete(`/users/${id}`);
      commit("removeUser", id);
      return response.data;
    } catch (error) {
      console.error("Failed to delete user:", error);
      throw error;
    }
  },
  async restoreUserById({ commit }, id) {
    try {
      const response = await axios.post(`/users/${id}/restore`);
      commit("updateUser", response.data);
    } catch (error) {
      console.error("Failed to restore user:", error);
      throw error;
    }
  },
};

const mutations = {
  setUsers(state, users) {
    state.users = users.data; // Ensure this matches your API's response structure
  },
  addUser(state, user) {
    state.users.push(user);
  },
  updateUser(state, updatedUser) {
    const index = state.users.findIndex(
      (user) => user.id === updatedUser.id
    );
    if (index !== -1) {
      state.users.splice(index, 1, updatedUser);
    }
  },
  removeUser(state, id) {
    state.users = state.users.filter(
      (user) => user.id !== id
    );
  },
  resetUsers(state) {
    state.users = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
